<div [ngClass]="{ container: addContainer }">
  <div class="row">
    <div class="col">
      @if (showControls) {
        <div>
          <button class="btn btn-secondary btn-sm float-end" (click)="openNewWindow()">Open in new tab</button>
        </div>
      }

      @if (html) {
        <ch-static-html [html]="html"></ch-static-html>
      }
    </div>
  </div>
</div>
